import { paramView } from '../constants/parameterNames';
import { success } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';

const description =
    'Switches the form\'s view to the indicated view. This is useful for times when you are using rules on a field and the "Switch views" rule action is not available, or when the view to switch to is determined dynamically.';

const requiredParameters = {
    [paramView]: {
        description: 'View name',
    },
};

const executeAsync = async ({ parameters, viewManager }) => {
    const viewName = getParamValue(parameters, paramView);

    await viewManager.setCurrentView(viewName);

    return success();
};

const SetDefaultView = {
    description,
    executeAsync,
    requiredParameters,
};

export default SetDefaultView;
